import React from 'react';
import styled from 'styled-components';
import { CardsList } from '../shared/CardsList';
import { FeedbackStyled, FullHeight, QuestionTextStyled } from './shared/components';

const StyledTableContainer = styled.div`
  width: 100%;
  @media (min-width: ${({ theme }) => theme.viewports.sm}) and (max-height: 700px) {
    height: 100%;
    padding-top: 20px;
  }

  .container {
    padding: 0;
    width: 100%;
  }

  .half-height {
    @media (min-width: ${({ theme }) => theme.viewports.md}) {
      min-height: 115px;
    }
  }

  @media (max-width: 767px) and (orientation: portrait) {
    body[data-testid='HSII'] & {
      .container h1 {
        font-size: 16px;
        color: #000;
        margin-bottom: 5px;
      }

      .custom-table td,
      .custom-table th {
        padding: 5px !important;
      }

      table.custom-table td,
      table.custom-table th {
        font-size: 14px !important;
      }
    }
  }

  @media (max-width: 967px) and (orientation: landscape) {
    body[data-testid='HSII'] & {
      .container h1 {
        font-size: 16px;
        color: #000;
        margin-bottom: 5px;
      }

      .custom-table td,
      .custom-table th {
        padding: 5px !important;
      }

      table.custom-table td,
      table.custom-table th {
        font-size: 14px !important;
      }
    }
  }
`;

const QuestionWichTextStyled = styled(QuestionTextStyled)`
  margin-bottom: 0;
  font-size: 19px;
  line-height: 1.4;
  margin-top: 10px;

  @media (max-width: 767px) and (orientation: portrait) {
    text-align: center;
    font-size: 16px;
    margin-top: 5px;
  }

  @media (max-width: 967px) and (orientation: landscape) {
    text-align: center;
    font-size: 16px;
    margin-top: 5px;
  }

  @media (min-width: ${({ theme }) => theme.viewports.sm}) {
    font-size: 24px;
  }

  @media only screen and (min-width: ${({ theme }) => theme.viewports.sm}) and (max-device-width: ${({ theme }) =>
      theme.viewports.mdx}) and (orientation: portrait) {
    margin-top: 50px;
  }
`;

const StyledTable = styled.div`
  color: #375563 !important;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  h3,
  p {
    margin-top: 0 !important;
    margin-bottom: 10px !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    text-align: center;

    @media (min-width: ${({ theme }) => theme.viewports.sm}) {
      font-size: 18px !important;
    }
  }

  & + table:not(.custom-table) {
    margin-bottom: 10px;
  }

  table:not(.custom-table) {
    border: 1px solid #688695 !important;
    width: calc(100% - 1px);
    border-collapse: collapse;

    thead,
    thead tr {
      background-color: #e7f6fc !important;
    }

    caption {
      margin-bottom: 10px;
      font-weight: 500 !important;
      font-size: 14px !important;
      @media (min-width: ${({ theme }) => theme.viewports.sm}) {
        font-size: 18px !important;
      }
    }

    tr:nth-child(even) {
      background-color: #f4f4f4;
    }

    th,
    td {
      border: 1px solid #688695 !important;
      padding: 2px !important;
      font-size: 12px !important;

      @media (min-height: 600px) {
        font-size: calc(3.3333333333vh - 8px) !important;
        //padding: calc(1.6666666667vh - 8px) !important;
      }

      @media (min-height: 720px) {
        font-size: 13px !important;
      }

      @media (min-width: 768px) {
        font-size: calc(1.1594202899vw + 3.0956521739px) !important;
      }
      @media (min-width: 1113px) {
        font-size: 16px !important;
      }
    }

    td > div {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  table#crtbin-table3 thead > tr,
  table#crtbin-table3 tr:last-child,
  table#crtbin-table3 th {
    border: 1px solid #688695 !important;
  }
  .table#tableeg1 {
    max-width: 100%;
  }
`;

export const TextAndTable = ({
  values: { mainitem, responses, table, feedback, feedbackCorrectResponseIndex },
  selectedResponse,
  onResponse,
  config,
  isBlockModalVisible,
  isHelpVisible,
  isSidePanelOpen,
}) => {
  return (
    <>
      <FullHeight>
        <StyledTableContainer>
          <StyledTable
            dangerouslySetInnerHTML={{
              __html: table,
            }}
          />
          <QuestionWichTextStyled
            dangerouslySetInnerHTML={{
              __html: mainitem,
            }}
          />
          {!!feedback && (
            <FeedbackStyled
              dangerouslySetInnerHTML={{
                __html: feedback,
              }}
            />
          )}
        </StyledTableContainer>
      </FullHeight>
      <CardsList
        isAbstract={config.isAbstract}
        className="for-tables"
        items={responses}
        selectedResponse={feedbackCorrectResponseIndex || selectedResponse}
        onResponse={onResponse}
        config={config}
        isBlockModalVisible={isBlockModalVisible}
        isHelpVisible={isHelpVisible}
        isSidePanelOpen={isSidePanelOpen}
      />
    </>
  );
};
